define('js/../../cloud-mobile/js/store',[],function() {
    'use strict';

    var store = {
        get: function() {},
        set: function() {}
    };

    try {
        if (window['localStorage']) {
            store = {
                get: function(key) {
                    var res = window['localStorage'].getItem(key);
                    try {
                        res = JSON.parse(res);
                    } catch (error) {} // eslint-disable-line no-empty
                    return res;
                },
                set: function(key, value) {
                    value = typeof value == 'string' ? value : JSON.stringify(value);
                    try {
                        window['localStorage'].setItem(key, value);
                    } catch (error) {} // eslint-disable-line no-empty
                }
            };
        }
    } catch (error) {} // eslint-disable-line no-empty

    return store;
});

